import React, { memo } from 'react';
import { translate } from '@utils/i18n';
import { Text } from '@ui';
import snakeToCapitalize from '@utils/functions/snakeToCapitalize';
const formatIssuesText = (count, type, duration) => {
    // Special case for specific process types
    if (type === 'unanswered_questions' || type === 'missing_signatures' || type === 'missing_photos') {
        return `${translate('subprocess.ran_for', {
            namespace: 'features.iim_review.submissions_timeline',
            duration
        })}. ${count} ${count === 1
            ? translate('subprocess.issue', { namespace: 'features.iim_review.submissions_timeline' })
            : translate('subprocess.issues', { namespace: 'features.iim_review.submissions_timeline' })}.`;
    }
    return `${count} ${count === 1
        ? translate('subprocess.issue', { namespace: 'features.iim_review.submissions_timeline' })
        : translate('subprocess.issues', { namespace: 'features.iim_review.submissions_timeline' })}`;
};
function SubprocessItem({ subprocess }) {
    const { processType, durationSeconds, issuesCount, errors, executionId } = subprocess;
    const description = formatIssuesText(issuesCount, processType, Math.round(durationSeconds));
    return (React.createElement("div", { className: "subprocess-item", role: "region", "aria-label": `${snakeToCapitalize(processType)} process details`, "data-execution-id": executionId },
        React.createElement("div", { className: "subprocess-header" },
            React.createElement(Text, { variant: "x-small", as: "h4", className: "subprocess-title" }, snakeToCapitalize(processType)),
            subprocess.inProgress && (React.createElement(Text, { variant: "x-small", as: "span", className: "subprocess-status in-progress" }, translate('subprocess.in_progress', { namespace: 'features.iim_review.submissions_timeline' })))),
        React.createElement("div", { className: "subprocess-content" },
            errors.map((error, i) => (React.createElement("div", { className: "subprocess-error", key: i },
                React.createElement(Text, { variant: "x-small", as: "span", className: "error-message" }, error)))),
            React.createElement("div", { className: "subprocess-result" },
                React.createElement(Text, { variant: "x-small", as: "span", className: "qmb-link", tabIndex: 0, role: "button", "aria-label": `${translate('subprocess.view_issues', {
                        namespace: 'features.iim_review.submissions_timeline'
                    })} ${description}` }, description)))));
}
export default memo(SubprocessItem);
